'use client';

import { ChakraProvider } from '@chakra-ui/react';
import { theme } from '@/config/theme';
import { QueryProvider } from '../context/QueryProvider';
type LayoutProps = {
  children: React.ReactNode;
};

const Layout = ({ children }: LayoutProps): JSX.Element => {
  return (
    <ChakraProvider theme={theme}>
      <QueryProvider>
        <>{children}</>
      </QueryProvider>
    </ChakraProvider>
  );
};

export default Layout;
